<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

            <h2>Competencias</h2>
            <p>Esta tela é destinada a criação e gerenciamento das competências de trabalho para este simulador.</p>

            <div class="form-group mt-4">
                <label for="label" class="input-label">Pesquisar por:</label>
                <div class="form-group">
                    <select placeholder="Selecione" v-model="pesquisar_por" class="form-control">
                        <option value="descricao" selected>Nome da Competência</option>
                        <option value="usuario">Nome de professor</option>
                    </select>
                </div>
            </div>

            <div class="form-group mt-1">
                <label for="label" class="input-label">Nome a pesquisar:</label>
                <input type="text" id="campo_pesquisar" class="form-control" v-model="campo_pesquisar" required placeholder="Nome a pesquisar">
            </div>
            <div style="text-align: right; width: 100%;" class="mb-1 mt-1">
                <button @click="CarregarCompetencias(campo_pesquisar, pesquisar_por)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 180px; background-color: rgb(235, 234, 234); cursor: pointer;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">search</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Pesquisar</label>
                </button>
            </div>
            <div style="text-align: right; width: 100%;" class="mb-4 mt-1">
                <button @click="abrirModal(null, null, null)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 180px; background-color: rgb(235, 234, 234); cursor: pointer;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">add</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Nova Competência</label>
                </button>
            </div>

            <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>Competências cadastrados</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Descrição</th>
                                                <th scope="col" style="background-color: lightgrey;">Professores</th>
                                                <th scope="col" style="background-color: lightgrey;">Total Professores</th>
                                                <th scope="col" style="background-color: lightgrey;">Editar Competência</th>
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="competencia in competencias">
                                                <td style="text-align: right; vertical-align: middle;">{{ competencia.id }}</td>
                                                <td style="text-align: left; vertical-align: middle;">{{ competencia.descricao }}</td>
                                                <td style="text-align: left; vertical-align: middle;">
                                                    <ul style="list-style-type: none; padding-left: 0;">
                                                        <li v-for="usuario in competencia.professores" :key="usuario.id">{{ usuario.name }}</li>
                                                    </ul>
                                                </td>
                                                <td style="text-align: right; vertical-align: middle;">{{ competencia.professores.length }}</td>
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="abrirModal(competencia.id, competencia.descricao, competencia.professores)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">edit</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Editar</label>
                                                    </button>
                                                </td>
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="deletarCompetencia(competencia.id)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ competencias.length }} competência(s) encontrado(s).</p>
                            </div>
                        </div>
                    </div>
                </div>

    </div>

                <!-- Modal -->
                <div class="modal fade" id="groupModal" tabindex="-1" role="dialog" aria-labelledby="groupModalLabel" aria-hidden="true"  v-show="exibirModal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="groupModalLabel">{{ modalTitle }}</h5>
                                <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="fecharModal">
                                    <span aria-hidden="true">&times;</span>
                                </button> -->
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="salvarCompetencia">
                                    <div class="form-group">
                                        <label for="descricaoGrupo">Descrição da Competência</label>
                                        <input type="text" class="form-control" id="descricaoGrupo" v-model="competencia.descricao">
                                    </div>
                                    <div class="form-group pos-sugestoes">
                                        <label for="professorGrupo">Adicionar Professor</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="professorGrupo"
                                            v-model="professor"
                                            @input="buscarProfessores"
                                        >
                                        <span style="font-size: x-small;">Digite e selecione os professores deste grupo.</span>

                                        <div class="lista-sugestoes" v-if="sugestoesUsuarios.length">
                                            <div v-for="usuario in sugestoesUsuarios" :key="usuario.id" @click="adicionarProfessor(usuario)">
                                                {{ usuario.name }} - {{ usuario.email }}
                                            </div>
                                        </div>


                                    </div>

                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Professor</th>
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="professor in competencia.professores">
                                                <td style="text-align: right; vertical-align: middle;">{{ professor.id }}</td>
                                                <td style="text-align: left; vertical-align: middle;">{{ professor.name }}</td>
                                                
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerProfessor(professor.id)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ competencia.professores.length }} professor(es) encontrado(s).</p>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="fecharModal">Fechar</button> -->
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="salvarCompetencia">
                                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span> 
                                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Salvar Competência</label>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


  </template>
  
<script>
  import axios from 'axios';
  import { Modal } from 'bootstrap';
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            pesquisar_por: '',
            campo_pesquisar: '',
            competencias: [],

            //Variaveis para o modal
            exibirModal: false,
            competencia: {
                descricao: '',
                professores: []
            },
            professor: '',
            sugestoesUsuarios: [],
            modalTitle: 'Novo Grupo',

            

        };
        
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    methods: {
        CarregarCompetencias(filtro = '', opcaoFiltro = 'descricao'){

            axios.get(this.BASE_URL + 'buscar_competencias', {
                    params: {
                        filtro: filtro,
                        opcaoFiltro: opcaoFiltro
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        this.competencias = response.data;
                    } else {
                        alert('Erro ao deletar registro.');
                    }
                })
                .catch(error => {
                    alert('Erro ao buscar registros: ' + error);
                    console.error(error);
                });
        },

        abrirModal(idDaCompetencia = null, descricao_competencia = null, usuarios_competencia = null) {
            if (idDaCompetencia) {
                this.competencia = { descricao: descricao_competencia, professores: usuarios_competencia, id: idDaCompetencia};
                
            } else {
                // Configuração para um novo grupo
                this.competencia = { descricao: '', professores: [] };
                this.modalTitle = 'Nova Competencia';
                this.exibirModal = true;
            }

            console.log(this.grupo);

            this.$nextTick(() => {
                new Modal(document.getElementById('groupModal')).show();
            });
        },
        fecharModal() {
            new Modal(document.getElementById('groupModal')).hide();
        },
        buscarProfessores() {
            if (this.professor.length > 2) {
                axios.get(this.BASE_URL + 'usuarios_admin/buscar', { params: { query: this.professor } })
                    .then(response => {
                        this.sugestoesUsuarios = response.data;
                    })
                    .catch(error => {
                        alert('Erro na busca:', error);
                        console.error('Erro na busca:', error);
                    });

            }
        },
        adicionarProfessor(usuario) {

            const jaEstaNaCompetencia = this.competencia.professores.some(
                professor => professor.id === usuario.id
            );

            if (!jaEstaNaCompetencia) {
                this.competencia.professores.push(usuario);
            } else {
                alert("Este usuário já foi adicionado a esta competência.");
            }

            this.professor = '';
            this.sugestoesUsuarios = [];

            // Só salva automaticamente se já for uma competência existente
            if (this.competencia.id) {
                this.enviarCompetencia();
            }
        },

        removerProfessor(idProfessor) {
            this.competencia.professores = this.competencia.professores.filter(
                professor => professor.id !== idProfessor
            );

            if (this.competencia.id) {
                this.enviarCompetencia();
            }
        },
        enviarCompetencia() {

            axios.post(this.BASE_URL + 'competencia/salvar', this.competencia)
                .then(response => {
                    const retorno = response.data;

                    // GUARDA o id na competência para as próximas chamadas
                    this.competencia.id = retorno.id;

                    // Atualiza a lista de professores com o que veio do backend
                    // (caso você queira manter sincronizado)
                    if (retorno.professores) {
                        this.competencia.professores = retorno.professores;
                    }

                })
                .catch(error => {
                    console.error("Erro ao salvar a Competência:", error);
                });
        },

        salvarCompetencia(){
            this.enviarCompetencia();
            alert("Competência salva com sucesso!");
            window.location.reload();
        },
        deletarCompetencia(id) {
            if(confirm("Tem certeza que deseja deletar esta competência?")) {
                axios.post(this.BASE_URL + 'competencia/remover/' + id)
                    .then(response => {
                        alert("Competência deletado com sucesso!");
                        this.CarregarCompetencias();
                    })
                    .catch(error => {
                        console.error("Erro ao deletar o competência:", error);
                    });
            }
        }

    },
    mounted() {
        this.CarregarCompetencias();
    },
    
};
</script>

<style scoped>
/* wrapper do input precisa ser relative pra ancorar o dropdown */
.pos-sugestoes {
    position: relative;
}

/* container da lista vira um dropdown suspenso */
.lista-sugestoes {
    position: absolute;
    top: 100%;          /* logo abaixo do input */
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 0 0 4px 4px;
    max-height: 200px;  /* pra não ficar gigante */
    overflow-y: auto;
    z-index: 1000000;   /* acima do conteúdo do modal */
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

/* itens da lista (mantendo o que você já tinha) */
.lista-sugestoes div {
    cursor: pointer;
    padding: 5px 8px;
    border-bottom: 1px solid #eee;
}

.lista-sugestoes div:last-child {
    border-bottom: none;
}

.lista-sugestoes div:hover {
    background-color: #f0f0f0;
}
</style>
